import { extendTheme } from '@chakra-ui/react';
import {
  ASSET_COLOR,
  BG_ALTERNATIVE,
  BG_LAYER,
  BG_PRIMARY,
  BG_SECONDARY,
  TEXT_ALTERNATIVE,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
} from '@/constants/colors';
import { FONT_FAMILY } from '@/constants/default-props';

const breakpoints = {
  base: '0px',
  xs: '375px',
  sm: '480px',
  md: '768px',
  lg: '992px',
  xl: '1280px',
  '2xl': '1536px',
};

const theme = {
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
  },
  breakpoints,
  fonts: {
    heading: FONT_FAMILY.heading,
    subHeading: FONT_FAMILY.subHeading,
    body: FONT_FAMILY.body,
    pinyon: `'Pinyon Script', cursive;`,
    jost: `'Jost', sans-serif;`,
    delafield: `'Mrs Saint Delafield', cursive;`,
    justAnotherHand: `'Just Another Hand', cursive;`,
  },
  fontSizes: {
    heading: '36px',
    subHeading: '58px',
    body: '16px',
    body_lv2: '18px',
  },
  fontWeights: {
    heading: 400,
    subHeading: 400,
    body: 400,
    body_lv2: 600,
  },
  colors: {
    bgPrimary: BG_PRIMARY,
    bgSecondary: BG_SECONDARY,
    bgAlternative: BG_ALTERNATIVE,
    backgroundAssetColor: BG_LAYER,
    mainAssetColor: ASSET_COLOR,
    mainColorText: TEXT_PRIMARY,
    secondaryColorText: TEXT_SECONDARY,
    alternativeColorText: TEXT_ALTERNATIVE,
  },
};

export default extendTheme(theme);
